'use client';

import {useEffect} from 'react';
import {Provider} from 'react-redux';
import {store} from 'lib/redux/store';
import Trace from 'more-trace';
import {configureAmplify} from '@/csa/graphql/amplify.configure';

configureAmplify();

const StoreProvider = ({children}: {children: React.ReactNode}) => {
  useEffect(() => {
    Trace.init({
      api_key: `${process.env.NEXT_PUBLIC_TRACE_API_KEY}`,
      url: `${process.env.NEXT_PUBLIC_TRACE_URL}`,
      env: `${process.env.NEXT_PUBLIC_TRACE_ENV}`,
      app_name: `${process.env.NEXT_PUBLIC_TRACE_APP_NAME}`,
    });
  }, []);

  return <Provider store={store}>{children}</Provider>;
};

export default StoreProvider;
